import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abbreviateNumberPipe'
})
export class AbbreviateNumberPipe implements PipeTransform {

  /**
   * @param value The number to format
   * @param minAbbreviate The minimum value to start abbreviating (default 10000)
   */
  transform(value: number | string, minAbbreviate: number = 1000): string {
    if (value === null || value === undefined || isNaN(Number(value))) return '';

    const num = Number(value);

    // Show as normal if below minAbbreviate
    if (num < minAbbreviate) return num.toLocaleString();

    const suffixes = ['', 'K', 'M', 'B', 'T'];
    const suffixNum = Math.floor(Math.log10(num) / 3);
    let shortValue = num / Math.pow(1000, suffixNum);

    // Round to nearest integer
    shortValue = Math.round(shortValue);

    return shortValue + suffixes[suffixNum];
  }
}
